/**
 * @fileoverview Contiene los servicios de consumo a la API para sistemas
 *
 * @version 1.0
 *
 * @author José Antonio Rodríguez Barceló <rbsistemas@hotmail.com>
 *
 * @copyright Shuttle Express México
 *
 * Historial
 * ---------
 * La primera versión fue escrita por José Antonio Rodríguez Barceló
 */

import api from '@/services/api'
const END_POINT = '/sistemas'

export default {
  /**
   * @name getSystems
   * @description Obtiene un listado de documentos segun parametros
   *
   * @param {*} params campo1 -> Parametros para poblar el select
   * @returns {array} devuelve un arreglo de json con los documentos
   */
  getSystems(params) {
    if (params != null) {
      return api.get(END_POINT + '/' + params)
    }
    return api.get(END_POINT)
  },

  /**
   * @name postSystem
   * @description Crea un nuevo documento
   *
   * @param {*} body Input del diálogo -> Propiedades para crear el documento
   * @returns {json} json con el resultado de crear un nuevo documento
   */
  postSystem(body) {
    return api.post(END_POINT + '/', body)
  },

  /**
   * @name patchSystem
   * @description Actualiza un documento por su id
   *
   * @param {*} body Input del dialogo -> Propiedades para actualizar el documento
   * @param {*} id _id -> id del documento que se va a actualizar
   * @returns {json} json con el resultado de actualizar el documento
   */
  patchSystem(body, id) {
    return api.patch(END_POINT + '/' + id, body)
  },

  /**
   * @name deleteSystem
   * @description Elimina un documento por su id
   *
   * @param {*} id _id -> id del documento que se va a eliminar
   * @returns {json} json con el resultado de eliminar el documento
   */
  deleteSystem(id) {
    return api.delete(END_POINT + '/' + id)
  },
}
